module.exports = __webpack_public_path__ + "img/top.628e1882.svg";